<template>
  <div class="container en016">
    <HeadingOne class="-margin-md">秘密のことば設定</HeadingOne>

    <ErrorsAlert :errors="errors"></ErrorsAlert>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="1" type="secret"></MainWizard>
    </WizardGroup>

    <p>内容をご確認のうえ、よろしければ「設定する」を押してください。</p>

    <form novalidate @submit.prevent="submitSecretQuestions()">
      <section>
        <TableBox class="-entry _mb-30">
          <TableBody>
            <TableRow>
              <TableHeader>質問1</TableHeader>
              <TableData>{{
                displaySecretWordAsk(userData.secret_word_ask1)
              }}</TableData>
            </TableRow>
            <TableRow>
              <TableHeader>質問1の答え</TableHeader>
              <TableData>{{ userData.secret_word_ans1 }}</TableData>
            </TableRow>
            <TableRow>
              <TableHeader>質問2</TableHeader>
              <TableData>{{
                displaySecretWordAsk(userData.secret_word_ask2)
              }}</TableData>
            </TableRow>
            <TableRow>
              <TableHeader>質問2の答え</TableHeader>
              <TableData>{{ userData.secret_word_ans2 }}</TableData>
            </TableRow>
            <TableRow>
              <TableHeader>質問3</TableHeader>
              <TableData>{{
                displaySecretWordAsk(userData.secret_word_ask3)
              }}</TableData>
            </TableRow>
            <TableRow>
              <TableHeader>質問3の答え</TableHeader>
              <TableData>{{ userData.secret_word_ans3 }}</TableData>
            </TableRow>
          </TableBody>
        </TableBox>

        <NoticeBox class="-point _mb-sm-40 _mb-md-60">
          <NoticeBody
            >au PAY
            スマートローンのご利用にあたって重要な情報となりますので、暗証番号の管理と同様に、お客さまご自身で厳重に管理していただきますようお願します。</NoticeBody
          >
        </NoticeBox>

        <BtngroupSingle class="_mb-sm-40">
          <BtnMain class="-main" @click.prevent="submitSecretQuestions">
            設定する
          </BtnMain>
        </BtngroupSingle>

        <BtngroupSingle class="-margin-lg">
          <BtnBack class="-back -md" router-name="en015"> 修正する </BtnBack>
        </BtngroupSingle>
      </section>
    </form>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  submitSecretQuestionsLambdaInvoke,
  getUserDataLambdaInvoke,
} from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import { secretWordAsks } from "@/constants/constant";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeBody from "@/components/box/NoticeBody";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";

export default {
  name: "En016",
  components: {
    BtnBack,
    BtnMain,
    BtngroupSingle,
    NoticeBody,
    NoticeBox,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    ErrorsAlert,
    MainWizard,
    WizardGroup,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "秘密のことば設定確認",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,秘密のことば",
    });
  },
  data() {
    return {
      errors: {},
      isDisabled: false,
      userData: {
        secret_word_ask1: "",
        secret_word_ans1: "",
        secret_word_ask2: "",
        secret_word_ans2: "",
        secret_word_ask3: "",
        secret_word_ans3: "",
      },
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitSecretQuestions: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            submitSecretQuestionsLambdaInvoke()
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$router.push({ name: "tem021" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    displaySecretWordAsk(target) {
      for (let secretWordAsk of secretWordAsks) {
        if (secretWordAsk.value === target) {
          return secretWordAsk.name;
        }
      }
      return "";
    },
  },
};
</script>

<style scoped></style>
